function $1669b27dd88d6d65$export$7d15b64cf5a3a4c4(val, min, max) {
    if (min !== null && val < min) return min;
    if (max !== null && val > max) return max;
    return val;
}
function $1669b27dd88d6d65$export$3a89f8d6f6bf6c9f(from, to, t) {
    return from * (1 - t) + to * t;
}
function $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9(from, to, dt, halfLife) {
    return to + (from - to) * 2 ** (-dt / halfLife);
}
function $1669b27dd88d6d65$export$268edf54634cf0a0(from, to, modulo, dt, halfLife) {
    to = (to % modulo + modulo) % modulo;
    from = (from % modulo + modulo) % modulo;
    if (Math.abs(to - from) > Math.PI) {
        if (to < from) to += modulo;
        else to -= modulo;
    }
    return $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9(from, to, dt, halfLife);
}
function $1669b27dd88d6d65$export$ec8f24324718cffc(mean = 0, stdev = 1) {
    const u = 1 - Math.random(); // Converting [0,1) to (0,1]
    const v = Math.random();
    const z = Math.sqrt(-2 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
    // Transform to the desired mean and standard deviation:
    return z * stdev + mean;
}
class $1669b27dd88d6d65$export$ac4bca90992eed1 {
    x;
    y;
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    static splat(val) {
        return new $1669b27dd88d6d65$export$ac4bca90992eed1(val, val);
    }
    static random() {
        return new $1669b27dd88d6d65$export$ac4bca90992eed1(Math.random(), Math.random());
    }
    static rotated(angle) {
        return new $1669b27dd88d6d65$export$ac4bca90992eed1(Math.cos(angle), Math.sin(angle));
    }
    static get ZERO() {
        return $1669b27dd88d6d65$export$ac4bca90992eed1.splat(0);
    }
    clone() {
        return new $1669b27dd88d6d65$export$ac4bca90992eed1(this.x, this.y);
    }
    with_x(val) {
        this.x = val;
        return this;
    }
    with_y(val) {
        this.y = val;
        return this;
    }
    eq(other, other2) {
        if (other instanceof $1669b27dd88d6d65$export$ac4bca90992eed1) return this.x === other.x && this.y === other.y;
        if (typeof other === "number" && other2 === undefined) return this.x === other && this.y === other;
        if (typeof other === "number" && typeof other2 === "number") return this.x === other && this.y === other2;
        throw new TypeError("wrong types");
    }
    add(other, other2) {
        if (other instanceof $1669b27dd88d6d65$export$ac4bca90992eed1) {
            this.x += other.x;
            this.y += other.y;
            return this;
        }
        if (typeof other === "number" && other2 === undefined) {
            this.x += other;
            this.y += other;
            return this;
        }
        if (typeof other === "number" && typeof other2 === "number") {
            this.x += other;
            this.y += other2;
            return this;
        }
        throw new TypeError("wrong types");
    }
    sub(other, other2) {
        if (other instanceof $1669b27dd88d6d65$export$ac4bca90992eed1) {
            this.x -= other.x;
            this.y -= other.y;
            return this;
        }
        if (typeof other === "number" && other2 === undefined) {
            this.x -= other;
            this.y -= other;
            return this;
        }
        if (typeof other === "number" && typeof other2 === "number") {
            this.x -= other;
            this.y -= other2;
            return this;
        }
        throw new TypeError("wrong types");
    }
    mul(other, other2) {
        if (other instanceof $1669b27dd88d6d65$export$ac4bca90992eed1) {
            this.x *= other.x;
            this.y *= other.y;
            return this;
        }
        if (typeof other === "number" && other2 === undefined) {
            this.x *= other;
            this.y *= other;
            return this;
        }
        if (typeof other === "number" && typeof other2 === "number") {
            this.x *= other;
            this.y *= other2;
            return this;
        }
        throw new TypeError("wrong types");
    }
    div(other, other2) {
        if (other instanceof $1669b27dd88d6d65$export$ac4bca90992eed1) {
            this.x /= other.x;
            this.y /= other.y;
            return this;
        }
        if (typeof other === "number" && other2 === undefined) {
            this.x /= other;
            this.y /= other;
            return this;
        }
        if (typeof other === "number" && typeof other2 === "number") {
            this.x /= other;
            this.y /= other2;
            return this;
        }
        throw new TypeError("wrong types");
    }
    static lerp(a, b, t) {
        return a.clone().mul(1 - t).add(b.clone().mul(t));
    }
    static expDecay(a, b, dt, halfLife) {
        return new $1669b27dd88d6d65$export$ac4bca90992eed1($1669b27dd88d6d65$export$3fc18dbcbcb9fbd9(a.x, b.x, dt, halfLife), $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9(a.y, b.y, dt, halfLife));
    }
    rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const px = this.x;
        const py = this.y;
        this.x = px * cos - py * sin;
        this.y = px * sin + py * cos;
        return this;
    }
    dot(other) {
        return this.x * other.x + this.y * other.y;
    }
    norm2() {
        return this.dot(this);
    }
    norm() {
        return Math.sqrt(this.norm2());
    }
    clamp(min, max) {
        this.x = $1669b27dd88d6d65$export$7d15b64cf5a3a4c4(this.x, min?.x ?? null, max?.x ?? null);
        this.y = $1669b27dd88d6d65$export$7d15b64cf5a3a4c4(this.y, min?.y ?? null, max?.y ?? null);
        return this;
    }
    angleDiff(to) {
        return Math.atan2(this.y - to.y, this.x - to.x);
    }
}


const $9d936a2aecb96285$export$1a6c4fc8d15a2dc7 = "#202020";
const $9d936a2aecb96285$export$aa1377bf681dd4c = 0.5;
const $9d936a2aecb96285$export$69e7c67e01175915 = 30;
const $9d936a2aecb96285$export$9d9bf607fd7ae301 = 2;
const $9d936a2aecb96285$export$4c0520018ab717ff = 1000;
const $9d936a2aecb96285$export$430c9e7923438cb = 12000;
const $9d936a2aecb96285$export$de392dc4b0464cee = 0.05;
const $9d936a2aecb96285$export$35ff8d344d13d10a = 1 / 1500;
const $9d936a2aecb96285$export$550da5e6f606a2e8 = 0.05;
const $9d936a2aecb96285$export$5dd03f4cb1ddc364 = 500;
const $9d936a2aecb96285$export$93c7ceefae2f1d28 = 0.1;
const $9d936a2aecb96285$export$69cc419308fd0f55 = 20;
const $9d936a2aecb96285$export$4c95a087ed18185b = 1;
const $9d936a2aecb96285$export$b103f2621e5877bc = 1;
const $9d936a2aecb96285$export$1973f5976e44ab5c = 30;
const $9d936a2aecb96285$export$c44c6b960e9f579 = 2000;
const $9d936a2aecb96285$export$e27b48d041999894 = 1;
const $9d936a2aecb96285$export$ec1c7412b931f7ab = 0.05;
const $9d936a2aecb96285$export$dc495c824c25c50e = 0.01;
const $9d936a2aecb96285$export$2a6d03ede7f5d6e1 = 0.001;
const $9d936a2aecb96285$export$312bb95bc1081b7a = 0.005;
const $9d936a2aecb96285$export$2eb4814db4757f56 = $9d936a2aecb96285$export$312bb95bc1081b7a / 3;
const $9d936a2aecb96285$export$c67e353a5495353e = {
    default: Object.freeze([
        100,
        136,
        234
    ]),
    close: Object.freeze([
        255,
        0,
        0
    ])
};
const $9d936a2aecb96285$export$49eaf9c07d75fba5 = {
    default: Object.freeze([
        236,
        189,
        0
    ]),
    close: Object.freeze([
        236,
        80,
        0
    ])
};
const $9d936a2aecb96285$export$ed2180585ae00a49 = {
    default: Object.freeze([
        0,
        0,
        0
    ]),
    close: Object.freeze([
        255,
        255,
        255
    ])
};
const $9d936a2aecb96285$export$12817be11599a63a = {
    default: Object.freeze([
        119,
        221,
        119
    ]),
    close: Object.freeze([
        119,
        221,
        119
    ])
};
const $9d936a2aecb96285$export$f9d786b65a27784d = {
    default: Object.freeze([
        255,
        255,
        255
    ]),
    close: Object.freeze([
        255,
        255,
        255
    ])
};




class $d273807f574c5850$export$646feb54fbadbe06 {
    renderer;
    started;
    pos;
    remainingLife;
    velocity;
    rotation;
    targetVelocity;
    interpolatedRadius;
    targetRadius;
    targetRotation;
    #opacity;
    closest;
    colorCfg;
    constructor(renderer, overrides){
        this.renderer = renderer;
        this.started = false;
        this.velocity = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
        this.rotation = 0;
        this.interpolatedRadius = 0;
        this.targetRotation = 0;
        this.#opacity = 1;
        this.closest = 9999;
        this.colorCfg = $9d936a2aecb96285$export$c67e353a5495353e;
        const radius = overrides?.radius ?? (0, $1669b27dd88d6d65$export$ec8f24324718cffc)(30, 5);
        const pos = overrides?.pos ?? (0, $1669b27dd88d6d65$export$ac4bca90992eed1).random().mul(renderer.canvas.width - radius * 2, renderer.canvas.height - radius * 2).add(radius);
        const velocity = overrides?.velocity ?? new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(0, (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)((0, $1669b27dd88d6d65$export$ec8f24324718cffc)(150, 75), 15, null));
        const life = overrides?.life ?? 99999;
        this.pos = pos;
        this.targetRadius = radius;
        this.remainingLife = life;
        this.targetVelocity = velocity;
        this.targetRotation = overrides?.rotation ?? 0;
    }
    static get displayName() {
        return "bubble";
    }
    get displayName() {
        // If a subclass overrides the static displayName this gets the right one
        return this.constructor?.displayName ?? "error";
    }
    get zindex() {
        return 0;
    }
    get maxRadius() {
        return this.targetRadius;
    }
    get radius() {
        if (!this.started) return this.targetRadius;
        return (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.interpolatedRadius, 0, null);
    }
    get forceRadius() {
        return this.radius / 2;
    }
    get opacity() {
        return this.#opacity;
    }
    get color() {
        const normal = this.colorCfg.default;
        const close = this.colorCfg.close;
        const closest = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.closest, 0, 1);
        const choice = [
            normal[0] * (1 - closest) + close[0] * closest,
            normal[1] * (1 - closest) + close[1] * closest,
            normal[2] * (1 - closest) + close[2] * closest
        ];
        return `rgba(${choice.map(Math.round).join(",")},${this.#opacity})`;
    }
    /// 0 if pos is at the surface or inside, 1 if 1 pixel from surface
    distanceFromSurface(pos) {
        return (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.pos.clone().sub(pos).norm() - this.radius, 0, null);
    }
    gapBetween(other) {
        const diff = other.pos.clone().sub(this.pos);
        const dist = diff.norm();
        const dir = diff.clone().div(dist);
        const a = other.distanceFromSurface(this.pos);
        if (a <= 0) return 0;
        const possibleContactPoint = this.pos.clone().add(dir.clone().mul(a));
        return this.distanceFromSurface(possibleContactPoint);
    }
    /// Apply velocities based on a close object
    applyObjectForce(dir, gap, forceRadius, forceMultiplier) {
        if (gap <= 0) return true;
        const sumedForceRadius = this.forceRadius + forceRadius;
        if (gap < sumedForceRadius) {
            const closness = 1 - gap / sumedForceRadius;
            this.closest = Math.max(closness, this.closest);
            let force = Math.pow(closness, 2) * forceMultiplier;
            this.velocity.add(dir.clone().mul(force));
        }
        return false;
    }
    updateWallsCollisions() {
        if (this.pos.y + this.radius > this.renderer.canvas.height) this.kill({
            type: "wall",
            dir: new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(0, 1)
        });
        if (this.pos.y - this.radius < 0) this.kill({
            type: "wall",
            dir: new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(0, -1)
        });
        if (this.pos.x + this.radius > this.renderer.canvas.width) this.kill({
            type: "wall",
            dir: new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(1, 0)
        });
        if (this.pos.x - this.radius < 0) this.kill({
            type: "wall",
            dir: new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(-1, 0)
        });
    }
    forceMultiplierWith(_other) {
        return 10;
    }
    updateBubbleCollisions() {
        this.closest = 0;
        for (const bubble of this.renderer.bubbles){
            if (bubble === this || bubble.isDying()) continue;
            const diff = this.pos.clone().sub(bubble.pos);
            const dist = diff.norm();
            const dir = diff.clone().div(dist);
            const gap = this.gapBetween(bubble);
            if (this.applyObjectForce(dir, gap, bubble.forceRadius, this.forceMultiplierWith(bubble))) {
                bubble.kill({
                    type: "bubble",
                    bubble: this
                });
                this.kill({
                    type: "bubble",
                    bubble: bubble
                });
            }
        }
    }
    get rotationInterpolationHalfLife() {
        return 0.1;
    }
    get velocityInterpolationHalfLife() {
        return 0.5;
    }
    get radiusInterpolationHalfLife() {
        return 0.05;
    }
    update() {
        if (this.isDead()) return;
        this.started = true;
        const dt = this.renderer.dt;
        this.remainingLife -= dt;
        if (this.isDying()) {
            this.interpolatedRadius *= 1 + dt * 2;
            this.#opacity = Math.pow(this.remainingLife / $9d936a2aecb96285$export$aa1377bf681dd4c, 3);
            return;
        }
        this.rotation = (0, $1669b27dd88d6d65$export$268edf54634cf0a0)(this.rotation, this.targetRotation, Math.PI * 2, dt, this.rotationInterpolationHalfLife);
        this.interpolatedRadius = (0, $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9)(this.interpolatedRadius, this.targetRadius, dt, this.radiusInterpolationHalfLife);
        this.velocity = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).expDecay(this.velocity, this.targetVelocity, dt, this.velocityInterpolationHalfLife);
        this.pos.add(this.velocity.clone().mul(dt));
        this.updateWallsCollisions();
        this.updateBubbleCollisions();
    }
    applyCtxTransform() {
        const ctx = this.renderer.ctx;
        ctx.translate(this.pos.x, this.pos.y);
        ctx.rotate(this.rotation);
    }
    draw() {
        const ctx = this.renderer.ctx;
        ctx.save();
        this.applyCtxTransform();
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(0, 0, this.radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
    }
    isDead() {
        return this.remainingLife < 0;
    }
    isDying() {
        return this.remainingLife < $9d936a2aecb96285$export$aa1377bf681dd4c;
    }
    kill(reason) {
        if (this.isDying()) return;
        this.remainingLife = $9d936a2aecb96285$export$aa1377bf681dd4c;
        if (reason.type === "bubble" || reason.type == "mouse") this.closest = 1;
    }
}





class $b8438b18d805648e$export$afb31c50083248d5 extends (0, $d273807f574c5850$export$646feb54fbadbe06) {
    pair = null;
    constructor(renderer, overrides){
        super(renderer, overrides);
        this.colorCfg = $9d936a2aecb96285$export$49eaf9c07d75fba5;
    }
    static get displayName() {
        return "golden";
    }
    get zindex() {
        return super.zindex + 1;
    }
    findPair() {
        if (this.pair !== null) {
            this.pair.pair = null;
            this.pair = null;
        }
        const range = $9d936a2aecb96285$export$69cc419308fd0f55 * this.radius;
        for (const bubble of this.renderer.bubbles){
            if (!(bubble instanceof $b8438b18d805648e$export$afb31c50083248d5)) continue;
            if (bubble === this) continue;
            if (bubble.isDying()) continue;
            const dist = bubble.pos.clone().sub(this.pos).norm2();
            if (dist > range ** 2) continue;
            if (bubble.pair === null) {
                this.pair = bubble;
                bubble.pair = this;
            }
        }
    }
    forceMultiplierWith(other) {
        if (other === this.pair) return 0;
        return super.forceMultiplierWith(other);
    }
    update() {
        super.update();
        const dt = this.renderer.dt;
        if (this.isDying()) {
            this.pair = null;
            return;
        }
        if (this.pair !== null && (this.pair.isDying() || !this.renderer.bubbles.includes(this.pair) || this.pair.pair !== this)) this.pair = null;
        if (this.pair === null) this.findPair();
        if (this.pair !== null) {
            const diff = this.pos.clone().sub(this.pair.pos);
            const dist = diff.norm();
            const force = diff.clone().div(dist).mul((0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(dist, 50, null)).mul(-1);
            this.velocity.add(force.mul(dt));
        }
    }
    draw() {
        super.draw();
        const ctx = this.renderer.ctx;
        if (this.pair !== null) {
            const target = this.pos.clone().sub(this.pair.pos).mul(0.5).add(this.pair.pos);
            ctx.strokeStyle = this.color;
            ctx.lineCap = "round";
            ctx.lineWidth = 5;
            ctx.beginPath();
            ctx.moveTo(this.pos.x, this.pos.y);
            ctx.lineTo(target.x, target.y);
            ctx.stroke();
        }
    }
    kill(reason) {
        const can_kill = [
            $b8438b18d805648e$export$afb31c50083248d5,
            (0, $f971f01cc25826da$export$7dbc21499ea59db9),
            (0, $e556eea54e6ccaf5$export$a6dc7c79385cc3d8),
            (0, $7568d23de12f6047$export$c51b14d2e762120e)
        ];
        if (reason.type === "bubble" && !can_kill.some((class_)=>reason.bubble instanceof class_)) return;
        if (reason.type === "wall") {
            if (reason.dir.x === 0) this.targetVelocity.y = Math.abs(this.targetVelocity.y) * Math.sign(-reason.dir.y);
            if (reason.dir.eq(1, 0)) this.pos.x = this.renderer.canvas.width - this.radius;
            if (reason.dir.eq(-1, 0)) this.pos.x = this.radius;
            return;
        }
        super.kill(reason);
    }
}




class $09a18608967404e7$export$2036fce9fd5edb37 extends (0, $d273807f574c5850$export$646feb54fbadbe06) {
    constructor(renderer, overrides){
        super(renderer, {
            rotation: Math.random() * Math.PI * 2,
            ...overrides
        });
    }
    draw() {
        const ctx = this.renderer.ctx;
        ctx.save();
        this.applyCtxTransform();
        ctx.fillStyle = this.color;
        ctx.fillRect(-this.radius, -this.radius, this.radius * 2, this.radius * 2);
        ctx.restore();
    }
    static get displayName() {
        return "square";
    }
    isInside(pos) {
        pos = pos.clone().sub(this.pos).rotate(-this.rotation);
        const hs = this.radius;
        return pos.x < hs && pos.y < hs && pos.x > -hs && pos.y > -hs;
    }
    distanceFromSurface(pos) {
        if (this.isInside(pos)) return 0;
        pos = pos.clone().sub(this.pos).rotate(-this.rotation);
        const hs = this.radius;
        const clamped = pos.clone().clamp((0, $1669b27dd88d6d65$export$ac4bca90992eed1).splat(-hs), (0, $1669b27dd88d6d65$export$ac4bca90992eed1).splat(hs));
        return clamped.sub(pos).norm();
    }
}





class $e556eea54e6ccaf5$export$a6dc7c79385cc3d8 extends (0, $d273807f574c5850$export$646feb54fbadbe06) {
    pair = null;
    constructor(renderer, overrides){
        super(renderer, {
            life: (0, $1669b27dd88d6d65$export$ec8f24324718cffc)(10, 3),
            ...overrides
        });
        this.targetVelocity = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
        this.colorCfg = $9d936a2aecb96285$export$ed2180585ae00a49;
    }
    static get displayName() {
        return "black hole";
    }
    get zindex() {
        return super.zindex + 2;
    }
    updateBubbleCollisions() {
        this.closest = 0;
        const dt = this.renderer.dt;
        for (const bubble of this.renderer.bubbles){
            if (bubble === this) continue;
            if (bubble.isDying()) continue;
            if (bubble instanceof $e556eea54e6ccaf5$export$a6dc7c79385cc3d8) continue;
            if (bubble instanceof (0, $7568d23de12f6047$export$c51b14d2e762120e)) continue;
            const diff = this.pos.clone().sub(bubble.pos);
            const dist = diff.norm();
            const force = 20000000 / Math.pow(dist, 1.5);
            const forceV = diff.clone().div(dist).mul(force);
            bubble.velocity.add(forceV.mul(dt));
        }
    }
    kill(reason) {
        if (reason.type === "wall") {
            if (reason.dir.eq(0, 1)) this.pos.y = this.renderer.canvas.height - this.radius;
            if (reason.dir.eq(0, -1)) this.pos.y = this.radius;
            if (reason.dir.eq(1, 0)) this.pos.x = this.renderer.canvas.width - this.radius;
            if (reason.dir.eq(-1, 0)) this.pos.x = this.radius;
            return;
        }
        if (reason.type === "bubble") {
            this.targetRadius += 1;
            return;
        }
        super.kill(reason);
    }
}





class $f971f01cc25826da$export$7dbc21499ea59db9 extends (0, $d273807f574c5850$export$646feb54fbadbe06) {
    currentTarget = null;
    underpopulatedSince = 0;
    constructor(renderer, overrides){
        super(renderer, overrides);
        this.targetVelocity = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
        this.colorCfg = $9d936a2aecb96285$export$12817be11599a63a;
    }
    static get displayName() {
        return "virus";
    }
    forceMultiplierWith(_other) {
        return 0;
    }
    get velocityInterpolationHalfLife() {
        return 0.25;
    }
    findNewTarget(blacklist = [
        (0, $e556eea54e6ccaf5$export$a6dc7c79385cc3d8),
        $f971f01cc25826da$export$7dbc21499ea59db9,
        (0, $7568d23de12f6047$export$c51b14d2e762120e)
    ], rec = true) {
        // slowest bubble
        let target = null;
        let targetValue = -Infinity;
        for (const bubble of this.renderer.bubbles){
            if (bubble.isDying()) continue;
            if (bubble === this) continue;
            if (blacklist.some((c)=>bubble instanceof c)) continue;
            const value = -bubble.velocity.norm2();
            if (value > targetValue) {
                let otherHasThisTarget = this.renderer.bubbles.some((other)=>other instanceof $f971f01cc25826da$export$7dbc21499ea59db9 && !other.isDying() && other.currentTarget === bubble);
                if (otherHasThisTarget) continue;
                targetValue = value;
                target = bubble;
            }
        }
        this.currentTarget = target;
    // if (!target && rec)
    //   return this.findNewTarget([], rec = false);
    }
    update() {
        super.update();
        if (this.currentTarget?.isDying()) this.currentTarget = null;
        if (this.currentTarget === null) this.findNewTarget();
        if (this.currentTarget === null) {
            this.underpopulatedSince += this.renderer.dt;
            if (this.underpopulatedSince > $9d936a2aecb96285$export$69e7c67e01175915) this.kill({
                type: "underpopulation_suicide"
            });
            this.targetVelocity = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
            return;
        }
        this.underpopulatedSince = 0;
        const diff = this.currentTarget.pos.clone().sub(this.pos);
        const dist = diff.norm();
        const force = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(dist * 3, this.currentTarget.velocity.norm() * 2, null);
        const dir = diff.clone().div(dist);
        this.targetRotation = dir.angleDiff((0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO);
        this.targetVelocity = dir.mul(force);
    }
    draw() {
        const ctx = this.renderer.ctx;
        ctx.save();
        this.applyCtxTransform();
        ctx.fillStyle = this.color;
        ctx.strokeStyle = this.color;
        ctx.lineCap = "round";
        ctx.lineWidth = 5;
        const angles = [
            0.00,
            0.25,
            0.50,
            0.75,
            1.00,
            1.25,
            1.50,
            1.75
        ].map((v)=>v * Math.PI);
        ctx.beginPath();
        ctx.arc(0, 0, this.radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        const outer_radius = this.radius * 1.25;
        for (const angle of angles){
            const targeta = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).rotated(angle).mul(this.radius);
            const targetb = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).rotated(angle).mul(outer_radius);
            ctx.moveTo(targeta.x, targeta.y);
            ctx.lineTo(targetb.x, targetb.y);
            const sa = angle - 0.1;
            const sb = angle + 0.1;
            const target1 = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).rotated(sa).mul(outer_radius);
            ctx.moveTo(target1.x, target1.y);
            ctx.arc(0, 0, outer_radius, sa, sb);
        }
        ctx.stroke();
        ctx.restore();
    }
    kill(reason) {
        if (reason.type === "wall") {
            if (reason.dir.eq(0, 1)) {
                this.pos.y = this.renderer.canvas.height - this.radius;
                if (this.velocity.y < 0) this.velocity.y = 0;
            }
            if (reason.dir.eq(0, -1)) {
                this.pos.y = this.radius;
                if (this.velocity.y < 0) this.velocity.y = 0;
            }
            if (reason.dir.eq(1, 0)) {
                this.pos.x = this.renderer.canvas.width - this.radius;
                if (this.velocity.x > 0) this.velocity.x = 0;
            }
            if (reason.dir.eq(-1, 0)) {
                this.pos.x = this.radius;
                if (this.velocity.x < 0) this.velocity.x = 0;
            }
            return;
        }
        const canKill = [
            (0, $e556eea54e6ccaf5$export$a6dc7c79385cc3d8),
            (0, $7568d23de12f6047$export$c51b14d2e762120e)
        ];
        if (reason.type === "bubble" && !canKill.some((class_)=>reason.bubble instanceof class_)) {
            if (!(this.currentTarget instanceof $f971f01cc25826da$export$7dbc21499ea59db9 && reason.bubble === this.currentTarget)) return;
        }
        super.kill(reason);
    }
}





class $7568d23de12f6047$var$AntiBody {
    renderer;
    antivirus;
    #target;
    #isGoingHome;
    opacity;
    relativePosition;
    position;
    rotation;
    speed;
    dead;
    get target() {
        return this.#target;
    }
    get started() {
        return this.#target !== null || this.#isGoingHome;
    }
    constructor(renderer, antivirus){
        this.renderer = renderer;
        this.antivirus = antivirus;
        this.#target = null;
        this.#isGoingHome = false;
        this.opacity = 0;
        this.speed = 0;
        this.dead = false;
        this.relativePosition = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).random().mul(2).sub(1).mul(antivirus.radius - 20);
        this.position = antivirus.pos.clone().add(this.relativePosition);
        this.rotation = Math.random() * Math.PI * 2;
    }
    start(target) {
        if (this.#target) throw new Error("Already a bubble");
        this.#target = target;
        this.speed = 0;
    }
    moveTowards(target) {
        const diff = target.clone().sub(this.position);
        const dist = diff.norm();
        if (dist === 0) return 0;
        const dir = diff.clone().div(dist);
        const targetRotation = dir.angleDiff((0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO) - Math.PI / 2;
        this.rotation = (0, $1669b27dd88d6d65$export$268edf54634cf0a0)(this.rotation, targetRotation, Math.PI * 2, this.renderer.dt, 0.05);
        this.speed = (0, $1669b27dd88d6d65$export$3fc18dbcbcb9fbd9)(this.speed, $9d936a2aecb96285$export$c44c6b960e9f579, this.renderer.dt, 0.5);
        const actualDir = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).rotated(this.rotation + Math.PI / 2);
        this.position.add(actualDir.clone().mul(this.speed).mul(this.renderer.dt));
        return dist;
    }
    update() {
        if (this.isDead()) return;
        this.opacity = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.opacity + this.renderer.dt * 5, 0, 1);
        if (!this.started) {
            this.opacity = Math.min(this.opacity, this.antivirus.opacity);
            this.position = this.antivirus.pos.clone().add(this.relativePosition);
            return;
        }
        if (this.#isGoingHome) {
            if (this.antivirus.isDying()) {
                this.dead = true;
                return;
            }
            this.moveTowards(this.antivirus.pos.clone().add(this.relativePosition));
            const dist_surf = this.antivirus.distanceFromSurface(this.position);
            if (dist_surf < 5) {
                this.#isGoingHome = false;
                return;
            }
            return;
        }
        if (this.#target === null) return;
        if (this.#target.isDying()) {
            this.#target = null;
            this.#isGoingHome = true;
            this.speed = 0;
            return;
        }
        const dist_surf = this.#target.distanceFromSurface(this.position);
        if (dist_surf < 10) {
            this.#target.kill({
                type: "other",
                message: "antibody"
            });
            this.dead = true;
            return;
        }
        this.moveTowards(this.#target.pos.clone());
    }
    get zindex() {
        return this.antivirus.zindex;
    }
    draw() {
        const ctx = this.renderer.ctx;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.rotate(this.rotation);
        const lowerSize = 20;
        const topSize = lowerSize / 2;
        const lineWidth = 3;
        const middleSep = 2;
        const topSep = 2;
        const angle = 30 / 180 * Math.PI;
        ctx.strokeStyle = `rgba(255,255,255,${this.opacity})`;
        ctx.lineWidth = lineWidth;
        ctx.lineCap = "round";
        const bottom = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(0, lowerSize);
        ctx.beginPath();
        const drawSide = (inv)=>{
            const x_diff = (lineWidth / 2 + middleSep / 2) * inv;
            ctx.moveTo(bottom.x + x_diff, bottom.y);
            ctx.lineTo(bottom.x + x_diff, 0);
            const topLeftAngle = -(-angle * inv + Math.PI / 2);
            ctx.moveTo(x_diff, 0);
            ctx.lineTo(Math.cos(topLeftAngle) * topSize + x_diff, Math.sin(topLeftAngle) * topSize);
            const dy = lineWidth / 2 + topSep;
            ctx.moveTo(Math.cos(topLeftAngle) * lineWidth + x_diff + dy * inv, Math.sin(topLeftAngle) * lineWidth + dy);
            ctx.lineTo(Math.cos(topLeftAngle) * topSize + x_diff + dy * inv, Math.sin(topLeftAngle) * topSize + dy);
        };
        drawSide(1);
        drawSide(-1);
        ctx.stroke();
        ctx.restore();
    }
    isDead() {
        return !this.started && this.antivirus.isDead() || this.dead;
    }
    afterRemove() {
        this.dead = true;
    }
}
function $7568d23de12f6047$var$isTargetBubble(b) {
    return b instanceof (0, $f971f01cc25826da$export$7dbc21499ea59db9) || b instanceof (0, $e556eea54e6ccaf5$export$a6dc7c79385cc3d8);
}
class $7568d23de12f6047$export$c51b14d2e762120e extends (0, $d273807f574c5850$export$646feb54fbadbe06) {
    antibodyToSpawnCount;
    freeAntibodies = [];
    antibodies = [];
    lastRay;
    lastRayTarget = null;
    lastRayAntibody = null;
    static targetedViruses = new WeakMap();
    constructor(renderer, overrides){
        super(renderer, {
            radius: (0, $1669b27dd88d6d65$export$ec8f24324718cffc)(40, 3),
            life: (0, $1669b27dd88d6d65$export$ec8f24324718cffc)(30, 5),
            ...overrides
        });
        this.targetVelocity = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
        this.colorCfg = $9d936a2aecb96285$export$f9d786b65a27784d;
        this.lastRay = renderer.totalTime - 999;
        this.antibodyToSpawnCount = overrides?.antibodies ?? 3;
    }
    static get displayName() {
        return "antivirus";
    }
    forceMultiplierWith(_other) {
        return 0;
    }
    get radiusInterpolationHalfLife() {
        return 0.2;
    }
    get zindex() {
        return super.zindex + 5;
    }
    draw() {
        const ctx = this.renderer.ctx;
        ctx.strokeStyle = this.color;
        ctx.lineWidth = 6;
        ctx.lineCap = "round";
        ctx.beginPath();
        const lastRay = (this.renderer.totalTime - this.lastRay) / $9d936a2aecb96285$export$b103f2621e5877bc;
        if (lastRay < 1 && this.lastRayTarget && this.lastRayAntibody) {
            const diff = this.pos.clone().sub(this.lastRayTarget.pos);
            const angle = diff.angleDiff((0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO) + Math.PI;
            const anim = Math.sin(Math.PI * lastRay);
            const opening = anim * (Math.PI / 4);
            if (lastRay > 0.25 && !this.lastRayAntibody.started) this.lastRayAntibody.start(this.lastRayTarget);
            ctx.arc(this.pos.x, this.pos.y, this.radius, angle + opening, Math.PI * 2 + angle - opening);
        } else ctx.arc(this.pos.x, this.pos.y, this.radius, 0, Math.PI * 2);
        ctx.stroke();
    }
    findTarget() {
        const range2 = ($9d936a2aecb96285$export$1973f5976e44ab5c * this.radius) ** 2;
        for (const bubble of this.renderer.bubbles){
            if (bubble === this) continue;
            if (bubble.isDying()) continue;
            if (!$7568d23de12f6047$var$isTargetBubble(bubble)) continue;
            if ($7568d23de12f6047$export$c51b14d2e762120e.targetedViruses.has(bubble)) continue;
            const dist2 = bubble.pos.clone().sub(this.pos).norm2();
            if (dist2 > range2) continue;
            return bubble;
        }
        return null;
    }
    update() {
        super.update();
        if (this.antibodyToSpawnCount > 0 && Math.abs(this.radius - this.targetRadius) < 5) {
            const antibody = new $7568d23de12f6047$var$AntiBody(this.renderer, this);
            this.antibodies.push(antibody);
            this.freeAntibodies.push(antibody);
            this.renderer.otherEntities.push(antibody);
            this.antibodyToSpawnCount -= 1;
        }
        if (this.isDying()) return;
        const lastRayIsFinished = this.renderer.totalTime - this.lastRay > $9d936a2aecb96285$export$b103f2621e5877bc;
        for (const antibody of this.antibodies)if (!this.freeAntibodies.includes(antibody) && (antibody !== this.lastRayAntibody || lastRayIsFinished) && !antibody.started) this.freeAntibodies.push(antibody);
        this.antibodies = this.antibodies.filter((a)=>!a.isDead());
        this.freeAntibodies = this.freeAntibodies.filter((a)=>!a.isDead() && !a.started);
        const freeAntibodies = this.freeAntibodies.length;
        if (freeAntibodies > 0 && this.renderer.totalTime - this.lastRay > $9d936a2aecb96285$export$4c95a087ed18185b) {
            const target = this.findTarget();
            if (target) {
                const antibody_i = this.freeAntibodies.findIndex((a)=>!a.started);
                this.lastRayAntibody = this.freeAntibodies[antibody_i];
                this.freeAntibodies.splice(antibody_i, 1);
                this.lastRay = this.renderer.totalTime;
                this.lastRayTarget = target;
                $7568d23de12f6047$export$c51b14d2e762120e.targetedViruses.set(target, this.lastRayAntibody);
            }
        }
        if (this.antibodies.length === 0 && this.antibodyToSpawnCount === 0) this.kill({
            type: "other",
            message: "no antibodies left"
        });
    }
    kill(reason) {
        if (reason.type === "wall") {
            if (reason.dir.eq(0, 1)) this.pos.y = this.renderer.canvas.height - this.radius;
            if (reason.dir.eq(0, -1)) this.pos.y = this.radius;
            if (reason.dir.eq(1, 0)) this.pos.x = this.renderer.canvas.width - this.radius;
            if (reason.dir.eq(-1, 0)) this.pos.x = this.radius;
            return;
        }
        if (reason.type === "bubble" && !(reason.bubble instanceof (0, $e556eea54e6ccaf5$export$a6dc7c79385cc3d8))) return;
        super.kill(reason);
    }
}


const $6d5308d30d6202ac$export$300de71f25a1e3e3 = {
    "bubble": {
        class_: (0, $d273807f574c5850$export$646feb54fbadbe06),
        probability: $9d936a2aecb96285$export$e27b48d041999894
    },
    "square": {
        class_: (0, $09a18608967404e7$export$2036fce9fd5edb37),
        probability: $9d936a2aecb96285$export$ec1c7412b931f7ab
    },
    "golden": {
        class_: (0, $b8438b18d805648e$export$afb31c50083248d5),
        probability: $9d936a2aecb96285$export$dc495c824c25c50e
    },
    "blackhole": {
        class_: (0, $e556eea54e6ccaf5$export$a6dc7c79385cc3d8),
        probability: $9d936a2aecb96285$export$2a6d03ede7f5d6e1
    },
    "virus": {
        class_: (0, $f971f01cc25826da$export$7dbc21499ea59db9),
        probability: $9d936a2aecb96285$export$312bb95bc1081b7a
    },
    "antivirus": {
        class_: (0, $7568d23de12f6047$export$c51b14d2e762120e),
        probability: $9d936a2aecb96285$export$2eb4814db4757f56
    }
};
function $6d5308d30d6202ac$export$d8525e0232b2f1db(renderer, overrides) {
    let possibilities = Object.values($6d5308d30d6202ac$export$300de71f25a1e3e3).map((v)=>({
            ...v
        }));
    const sum = possibilities.reduce((sum, p)=>sum + p.probability, 0);
    for (const p of possibilities)p.probability /= sum;
    possibilities.sort((a, b)=>b.probability - a.probability);
    let prob = Math.random();
    for (const poss of possibilities){
        if (poss.probability < prob) {
            prob -= poss.probability;
            continue;
        }
        return new poss.class_(renderer, overrides);
    }
    throw new Error("Could not attribute a bubble");
}






class $69fa9b067a89fbf8$var$Particle {
    renderer;
    forceField;
    maxAge;
    age;
    pos;
    opacity;
    velocity;
    oldPoses;
    static OLD_POSES_COUNT = 5;
    constructor(renderer, forceField, maxAge){
        this.renderer = renderer;
        this.forceField = forceField;
        this.maxAge = maxAge;
        this.age = 0;
        this.opacity = 1;
        this.velocity = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
        this.oldPoses = [];
        const angle = Math.random() * Math.PI * 2;
        const distance = (0, $1669b27dd88d6d65$export$ec8f24324718cffc)(forceField.radius, forceField.radius / 10);
        this.pos = forceField.pos.clone().add((0, $1669b27dd88d6d65$export$ac4bca90992eed1).rotated(angle).mul(distance));
        forceField.particleCount += 1;
    }
    afterRemove() {
        this.forceField.particleCount -= 1;
    }
    update() {
        const dt = this.renderer.dt;
        this.age += dt;
        if (this.isDead()) return;
        this.oldPoses.push(this.pos.clone());
        this.oldPoses.splice(0, (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.oldPoses.length - $69fa9b067a89fbf8$var$Particle.OLD_POSES_COUNT, 0, null));
        if (this.forceField.started) {
            this.pos.add(this.velocity.clone().mul(this.renderer.dt));
            this.opacity -= this.renderer.dt / this.forceField.duration;
            this.opacity = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(this.opacity, 0, 1);
            const force = this.velocity.clone().mul(this.renderer.dt).mul(5);
            for (const bubble of this.renderer.bubbles)if (bubble.distanceFromSurface(this.pos) <= 0) bubble.velocity.add(force);
            return;
        }
        const diff = this.forceField.pos.clone().sub(this.pos);
        const dist = diff.norm();
        if (dist < 5) {
            this.age = this.maxAge;
            return;
        }
        const speed = Math.pow(dist / 10 + 18, 1.75);
        this.velocity = diff.div(dist).mul(speed);
        this.pos.add(this.velocity.clone().mul(this.renderer.dt));
    }
    draw() {
        const ctx = this.renderer.ctx;
        if (this.oldPoses.length < 3) return;
        const oldest = this.oldPoses[0];
        const mid = this.oldPoses[Math.floor(this.oldPoses.length / 2)];
        const last = this.oldPoses[this.oldPoses.length - 1];
        ctx.strokeStyle = `rgba(255,255,255,${this.opacity})`;
        ctx.lineWidth = 5;
        ctx.lineCap = "round";
        ctx.beginPath();
        ctx.moveTo(oldest.x, oldest.y);
        ctx.bezierCurveTo(oldest.x, oldest.y, mid.x, mid.y, last.x, last.y);
        ctx.stroke();
    }
    isDead() {
        return this.age > this.maxAge || this.opacity === 0;
    }
    get zindex() {
        return 10;
    }
}
class $69fa9b067a89fbf8$export$92ff2910827ee71f {
    renderer;
    pos;
    started;
    age;
    #force;
    particleCount;
    constructor(renderer, pos){
        this.renderer = renderer;
        this.pos = pos;
        this.started = false;
        this.age = 0;
        this.#force = $9d936a2aecb96285$export$4c0520018ab717ff;
        this.particleCount = 0;
    }
    get zindex() {
        return 10;
    }
    start() {
        this.started = true;
    }
    get force() {
        return this.#force;
    }
    set force(n) {
        if (this.started) throw new Error("Cannot change force after started");
        this.#force = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(n, 0, $9d936a2aecb96285$export$430c9e7923438cb);
    }
    isDead() {
        return this.age > this.duration;
    }
    update() {
        if (this.isDead()) return;
        if (!this.started) {
            for(let i = 0; this.particleCount < $9d936a2aecb96285$export$5dd03f4cb1ddc364 && i < Math.ceil(this.radius * $9d936a2aecb96285$export$de392dc4b0464cee); i++)this.renderer.otherEntities.push(new $69fa9b067a89fbf8$var$Particle(this.renderer, this, 1));
            return;
        }
        this.age += this.renderer.dt;
        for (const bubble of this.renderer.bubbles){
            if (bubble.isDying()) continue;
            bubble.velocity.add(this.getForceOn(bubble).mul(this.renderer.dt));
        }
    }
    get duration() {
        return Math.pow(this.force * $9d936a2aecb96285$export$35ff8d344d13d10a, -0.8);
    }
    get radius() {
        const rad = this.force * $9d936a2aecb96285$export$550da5e6f606a2e8;
        if (!this.started) return rad;
        return (1 - this.opacity) * rad;
    }
    get opacity() {
        if (!this.started) return 1;
        const age_fact = this.age / this.duration;
        return 1 - age_fact;
    }
    get color() {
        return `rgba(255,255,255,${this.opacity})`;
    }
    draw() {
        const ctx = this.renderer.ctx;
        if (!this.started) return;
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.pos.x, this.pos.y, this.radius, 0, Math.PI * 2);
        ctx.fill();
    }
    getForceOn(bubble) {
        if (!this.started) return (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
        const diff = this.pos.clone().sub(bubble.pos);
        const dist = diff.norm();
        const dir = diff.clone().div(dist);
        const normalized_dist = (0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(dist - bubble.radius - this.radius, 0, null);
        if (normalized_dist > 1) return (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO;
        return dir.mul(-1).mul(this.force ** 1.5 * this.opacity);
    }
}





class $2df9534e584401e2$export$724f6b867059ef5f {
    renderer;
    abortController;
    constructor(renderer){
        this.renderer = renderer;
        this.abortController = new AbortController();
    }
    static getFromName(name) {
        if (name === "forceField") return $2df9534e584401e2$export$1442ad99691bf7b0;
        if (name === "deleter") return $2df9534e584401e2$export$b8c89c8a16ec74bd;
        if (name === "spawn") return $2df9534e584401e2$export$861cbca69cd592bd;
        return null;
    }
    init() {}
    update() {}
    clean() {
        this.abortController.abort();
    }
}
class $2df9534e584401e2$export$1442ad99691bf7b0 extends $2df9534e584401e2$export$724f6b867059ef5f {
    currentForceField = null;
    clean() {
        this.currentForceField?.start();
    }
    update() {
        const rend = this.renderer;
        if (rend.isClicking()) {
            if (this.currentForceField === null) {
                this.currentForceField = new (0, $69fa9b067a89fbf8$export$92ff2910827ee71f)(rend, (0, $1669b27dd88d6d65$export$ac4bca90992eed1).ZERO);
                rend.otherEntities.push(this.currentForceField);
            }
            if (rend.mousePos !== null) this.currentForceField.pos = rend.mousePos;
            this.currentForceField.force *= 1 + rend.dt * $9d936a2aecb96285$export$9d9bf607fd7ae301;
        }
        if (!rend.isClicking() && this.currentForceField !== null) {
            this.currentForceField.start();
            this.currentForceField = null;
        }
    }
}
class $2df9534e584401e2$export$b8c89c8a16ec74bd extends $2df9534e584401e2$export$724f6b867059ef5f {
    update() {
        const rend = this.renderer;
        if (!rend.isClicking()) return;
        const mp = rend.mousePos;
        if (!mp) return;
        for (const bubble of rend.bubbles)if (bubble.distanceFromSurface(mp) <= 0) bubble.kill({
            type: "mouse"
        });
    }
}
class $2df9534e584401e2$export$861cbca69cd592bd extends $2df9534e584401e2$export$724f6b867059ef5f {
    lastPlace = -Infinity;
    cfgElement;
    constructor(renderer){
        super(renderer);
        const el = document.getElementById("toolConfig");
        if (el === null || !(el instanceof HTMLDivElement)) throw new Error("Could not find config element");
        this.cfgElement = el;
    }
    init() {
        const options = Object.entries((0, $6d5308d30d6202ac$export$300de71f25a1e3e3)).map(([name, val])=>{
            const displayName = val.class_.displayName.split(" ").map((d)=>d[0].toUpperCase() + d.slice(1)).join(" ");
            return `<option value="${name}">${displayName}</option>`;
        });
        this.cfgElement.innerHTML = `
      <label>
        <span>Spawn bubble type: </span>
        <select id="spawner-tool-type">
          <option value="random">Random</option>
          ${options.join("")}
        </select>
      </label>
    `;
    }
    clean() {
        this.cfgElement.innerHTML = "";
    }
    get spawnerTypeInput() {
        const el = document.getElementById("spawner-tool-type");
        if (!el || !(el instanceof HTMLSelectElement)) return null;
        return el;
    }
    update() {
        const rend = this.renderer;
        if (this.renderer.totalTime - this.lastPlace < $9d936a2aecb96285$export$93c7ceefae2f1d28) return;
        if (!rend.isClicking()) return;
        const mp = rend.mousePos;
        if (!mp) return;
        const kind = this.spawnerTypeInput?.value ?? "random";
        let bubble;
        if (kind === "random") bubble = (0, $6d5308d30d6202ac$export$d8525e0232b2f1db)(rend, {
            pos: mp
        });
        else {
            const i = (0, $6d5308d30d6202ac$export$300de71f25a1e3e3)[kind];
            bubble = new i.class_(rend, {
                pos: mp
            });
        }
        if (this.renderer.trySpawnBall(bubble)) this.lastPlace = this.renderer.totalTime;
    }
}


class $0c7b277f82b1a352$export$3b14aa8c543ca7db extends Error {
    constructor(message){
        super(message);
    }
}


class $621f3774f67738fc$export$88530751e3977073 {
    canvas;
    ctx;
    totalTime = 0;
    dt = 0;
    bubbles = [];
    otherEntities = [];
    clicked = false;
    mouseLastPos = null;
    mousePos = null;
    mouseSpeed = null;
    lastMouseDown = null;
    lastMouseUp = null;
    currentTool;
    targetBubbleCount = 40;
    statusBar;
    constructor(canvas){
        this.canvas = canvas;
        const ctx = canvas.getContext("2d");
        if (!ctx) throw new (0, $0c7b277f82b1a352$export$3b14aa8c543ca7db)("No context?");
        this.ctx = ctx;
        const statusBar = document.getElementById("statusBar");
        if (statusBar === null || !(statusBar instanceof HTMLDivElement)) throw new (0, $0c7b277f82b1a352$export$3b14aa8c543ca7db)("Missing status bar element");
        this.statusBar = statusBar;
        let currentSelection = null;
        document.querySelectorAll("#toolbar>.tool").forEach((el)=>{
            if (!(el instanceof HTMLButtonElement)) {
                console.warn("Tool is not a button");
                return;
            }
            if (el.classList.contains("selected")) currentSelection = el.getAttribute("data-tool-name") ?? currentSelection;
            el.addEventListener("click", (e)=>{
                e.preventDefault();
                const newSelection = el.getAttribute("data-tool-name");
                if (newSelection === null) {
                    console.warn("Missing tool name on", el);
                    return;
                }
                const toolClass = (0, $2df9534e584401e2$export$724f6b867059ef5f).getFromName(newSelection);
                if (toolClass === null) {
                    console.warn("Invalid tool name on", el);
                    return;
                }
                this.currentTool.clean();
                this.currentTool = new toolClass(this);
                this.currentTool.init();
                const selected = document.querySelector("#toolbar>.selected");
                if (selected && selected instanceof HTMLButtonElement) {
                    selected.classList.remove("selected");
                    selected.disabled = false;
                }
                el.classList.add("selected");
                el.disabled = true;
            });
        });
        if (currentSelection === null) throw new Error("No default selected tool");
        const toolClass = (0, $2df9534e584401e2$export$724f6b867059ef5f).getFromName(currentSelection);
        if (toolClass === null) throw new Error("Default selected tool has invalid name");
        this.currentTool = new toolClass(this);
        this.currentTool.init();
        this.canvas.addEventListener("mousemove", (e)=>{
            this.mousePos = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(e.clientX, e.clientY);
        });
        this.canvas.addEventListener("mouseleave", ()=>{
            this.mousePos = null;
        });
        this.canvas.addEventListener("wheel", (e)=>{
            if (e.deltaY > 0) {
                this.targetBubbleCount -= 1;
                if (this.targetBubbleCount < 0) this.targetBubbleCount = 0;
            } else if (e.deltaY < 1) this.targetBubbleCount += 1;
        }, {
            passive: true
        });
        this.canvas.addEventListener("mousedown", (e)=>{
            if (e.button !== 0) return;
            e.preventDefault();
            if (this.mousePos === null) return;
            this.lastMouseDown = {
                pos: this.mousePos.clone(),
                time: this.totalTime
            };
            this.clicked = true;
        });
        this.canvas.addEventListener("mouseup", ()=>{
            if (this.mousePos === null) return;
            this.lastMouseUp = {
                pos: this.mousePos.clone(),
                time: this.totalTime
            };
        });
        this.canvas.addEventListener("touchstart", (t)=>{
            t.preventDefault();
            if (t.targetTouches.length === 1) {
                const touch = t.touches[0];
                this.mousePos = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(touch.clientX, touch.clientY);
            }
            if (t.targetTouches.length === 2) {
                const touchA = t.touches[0];
                const touchB = t.touches[1];
                const a = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(touchA.clientX, touchA.clientY);
                const b = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(touchB.clientX, touchB.clientY);
                this.mousePos = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).lerp(a, b, 0.5);
                this.lastMouseDown = {
                    pos: this.mousePos.clone(),
                    time: this.totalTime
                };
                this.clicked = true;
            }
        }, {
            passive: false
        });
        this.canvas.addEventListener("touchend", (t)=>{
            t.preventDefault();
            if (t.targetTouches.length === 0) {
                if (this.mousePos !== null && this.isClicking()) this.lastMouseUp = {
                    pos: this.mousePos.clone(),
                    time: this.totalTime
                };
                this.mousePos = null;
            }
            if (t.targetTouches.length === 1) {
                if (this.mousePos !== null && this.isClicking()) this.lastMouseUp = {
                    pos: this.mousePos.clone(),
                    time: this.totalTime
                };
                this.mousePos = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(t.touches[0].clientX, t.touches[0].clientY);
            }
        }, {
            passive: false
        });
        this.canvas.addEventListener("touchmove", (t)=>{
            t.preventDefault();
            if (t.targetTouches.length === 1) {
                const touch = t.touches[0];
                this.mousePos = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(touch.clientX, touch.clientY);
            }
            if (t.targetTouches.length === 2) {
                const touchA = t.touches[0];
                const touchB = t.touches[1];
                const a = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(touchA.clientX, touchA.clientY);
                const b = new (0, $1669b27dd88d6d65$export$ac4bca90992eed1)(touchB.clientX, touchB.clientY);
                this.mousePos = (0, $1669b27dd88d6d65$export$ac4bca90992eed1).lerp(a, b, 0.5);
            }
        }, {
            passive: false
        });
    }
    isClicking() {
        if (this.lastMouseDown === null) return false;
        if (this.lastMouseUp && this.lastMouseUp.time > this.lastMouseDown.time) return false;
        return true;
    }
    justClicked() {
        return this.clicked;
    }
    lastClickDuration() {
        if (this.lastMouseDown === null) return 0;
        return (this.lastMouseUp?.time ?? this.totalTime) - this.lastMouseDown.time;
    }
    timeSinceLastClick() {
        if (this.lastMouseDown === null) return this.totalTime;
        if (this.isClicking()) return 0;
        return this.totalTime - (this.lastMouseUp?.time ?? this.totalTime);
    }
    trySpawnBall(ball) {
        for (const other of this.bubbles){
            if (other.gapBetween(ball) <= 0) return false;
        }
        this.bubbles.push(ball);
        return true;
    }
    spawnBalls() {
        let count = this.bubbles.reduce((count, b)=>count + +!b.isDying(), 0);
        let max_try = (this.targetBubbleCount - count) * 2;
        while(max_try > 0 && count < this.targetBubbleCount){
            max_try -= 1;
            count += this.trySpawnBall((0, $6d5308d30d6202ac$export$d8525e0232b2f1db)(this)) ? 1 : 0;
        }
    }
    draw() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = (0, $9d936a2aecb96285$export$1a6c4fc8d15a2dc7);
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        const entities = [
            ...this.bubbles,
            ...this.otherEntities
        ];
        entities.sort((a, b)=>a.zindex - b.zindex);
        for (const ent of entities)ent.draw();
    }
    updateStatusBar() {
        let text = "balls, count: ";
        const counts = this.bubbles.reduce((counts, b)=>{
            if (b.isDying()) return counts;
            if (counts[b.displayName]) counts[b.displayName] += 1;
            else counts[b.displayName] = 1;
            return counts;
        }, {});
        text += Object.values(counts).reduce((a, b)=>a + b, 0);
        for (const key of Object.keys(counts)){
            if (key === "bubble") continue;
            text += ` (${counts[key]} ${key})`;
        }
        text += `, target: ${this.targetBubbleCount} (use scroll wheel)`;
        if (this.statusBar.innerText !== text) this.statusBar.innerText = text;
    }
    updateEntities(entities) {
        const toRemove = [];
        for (const entity of entities){
            entity.update();
            if (entity.isDead()) {
                toRemove.push(entity);
                continue;
            }
        }
        for (const byby of toRemove)entities.splice(entities.indexOf(byby), 1);
        for (const byby of toRemove)byby.afterRemove?.();
    }
    update(dt) {
        this.totalTime += dt;
        this.dt = dt;
        if (this.mousePos !== null && this.mouseLastPos !== null) this.mouseSpeed = this.mousePos.clone().sub(this.mouseLastPos).div(dt);
        else this.mouseSpeed = null;
        this.currentTool.update();
        this.updateEntities(this.bubbles);
        this.updateEntities(this.otherEntities);
        this.updateStatusBar();
        this.draw();
        this.spawnBalls();
        this.mouseLastPos = this.mousePos;
        this.clicked = false;
    }
}



function $b4e14b6b8da86996$var$init() {
    const canvas = document.getElementById("canvas");
    if (!canvas || !(canvas instanceof HTMLCanvasElement)) throw new Error("no");
    let onError = null;
    const promise = new Promise((_res, rej)=>{
        onError = rej;
    });
    const renderer = new (0, $621f3774f67738fc$export$88530751e3977073)(canvas);
    let lastT = 0;
    let animationFrame = null;
    const frame = (time)=>{
        try {
            time /= 1000;
            renderer.update((0, $1669b27dd88d6d65$export$7d15b64cf5a3a4c4)(time - lastT, 0, 0.5));
            lastT = time;
            if (animationFrame != null) cancelAnimationFrame(animationFrame);
            animationFrame = requestAnimationFrame(frame);
        } catch (e) {
            onError?.(e);
        }
    };
    const resizeCanvas = ()=>{
        canvas.width = document.body.clientWidth;
        canvas.height = document.body.clientHeight;
        frame(lastT);
    };
    resizeCanvas();
    new ResizeObserver(resizeCanvas).observe(document.body);
    return promise;
}
(async ()=>{
    try {
        await $b4e14b6b8da86996$var$init();
    } catch (e) {
        console.error(e);
        if (e instanceof (0, $0c7b277f82b1a352$export$3b14aa8c543ca7db)) alert("User error !: " + e.message);
        else if (e instanceof Error) alert("Just error !: " + e.message);
    }
})();


//# sourceMappingURL=index.e3d9f36d.js.map
